import reducer from 'components/datasources/reducers';
import App from 'components/datasources/container';
import renderer from 'controllers/react_renderer';

window.app.pages.DatasourcesIndex = function () {
  renderer.render(reducer, App, 'react-container', {
    datasource: app.data.datasource,
  });
};
